import React, { useEffect, useMemo, useRef, useState } from 'react';
import { PARTNER_COMPANY_FILTER_ALL } from '../../Utils/partnerCompanyFiltersUtils';

const PartnerCompanyFilterDropdown = ({
  label,
  value,
  options,
  onChange,
  allLabel = 'All',
  className = '',
  menuAlign = 'left',
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedOption = useMemo(
    () => options.find((option) => option.value === value),
    [options, value],
  );

  const isActive = value !== PARTNER_COMPANY_FILTER_ALL;
  const displayValue = selectedOption?.label || allLabel;

  useEffect(() => {
    const handleDocumentMouseDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleDocumentMouseDown);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleDocumentMouseDown);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handleSelect = (nextValue) => {
    onChange(nextValue);
    setOpen(false);
  };

  return (
    <div
      ref={rootRef}
      className={[
        'partner-company-filter-dd',
        isActive ? 'is-active' : '',
        open ? 'is-open' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      <button
        type="button"
        className="partner-company-filter-dd__trigger"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-haspopup="listbox"
      >
        <span className="partner-company-filter-dd__label">{label}</span>
        <span className="partner-company-filter-dd__value">{displayValue}</span>
        <span className={`partner-company-filter-dd__chevron ${open ? 'is-open' : ''}`} aria-hidden="true">
          ▾
        </span>
      </button>

      {open ? (
        <div
          className={`partner-company-filter-dd__menu partner-company-filter-dd__menu--${menuAlign}`}
          role="listbox"
          aria-label={`${label} filter options`}
        >
          {options.map((option) => {
            const isSelected = option.value === value;

            return (
              <button
                key={option.value}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`partner-company-filter-dd__item ${isSelected ? 'is-selected' : ''}`}
                onClick={() => handleSelect(option.value)}
              >
                <span className="partner-company-filter-dd__item-label">{option.label}</span>
                {isSelected ? <span className="partner-company-filter-dd__check" aria-hidden="true">✓</span> : null}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default PartnerCompanyFilterDropdown;
